import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Grid } from '@mui/material';

export const DocumentScoringResultSummaryBeta = ({ t, scoringResult }) => (
  <React.Fragment>
    <Grid container spacing={1}>
      <Grid item xs={12} md={4}>
        <strong>{t('DocumentEdit.Scoring.ScoringResult.EligibilityCriteria')} :</strong> <span>{scoringResult.EligibilityCriteria}</span>
      </Grid>
      <Grid item xs={12} sm={4} md={4}>
        <strong> {t('DocumentEdit.Scoring.ScoringResult.AssetScoreClass')} :</strong> <span>{scoringResult.assetRating}</span>
      </Grid>
    </Grid>
  </React.Fragment>
);
DocumentScoringResultSummaryBeta.propTypes = {
  t: PropTypes.func.isRequired,
  scoringResult: PropTypes.object.isRequired
};

export default withTranslation()(DocumentScoringResultSummaryBeta);
